import { formatDate } from "./dateFormatHelper";
type AvailabilityProps = {
  status?: string;
  onOffMarket?: string;
  availabilityDate?: string | undefined;
};

const isValidDate = (date: string) => {
  const parsedDate = new Date(date);
  return !isNaN(parsedDate.getTime());
};


const isBeforeToday = (date: string) => {
  const today = new Date();
  const compareDate = new Date(date);
  return compareDate < today;
};

export const AvailabilityString = ({
  status,
  onOffMarket,
  availabilityDate
}: AvailabilityProps) => {
  if (status !== "Available" || onOffMarket !== "On Market") {
    return "TBC";
  }

  if (availabilityDate && isValidDate(availabilityDate)) {
    return isBeforeToday(availabilityDate) ? "Now" : formatDate((new Date(availabilityDate)), "D MMM YYYY");
  }

  return status;
};

export const isAvailableBeforeDays = (iso?: string, days = 30): boolean => {
  if (!iso || days < 0) return false;

  const target = new Date(iso);
  if (Number.isNaN(target.getTime())) return false;

  const now = new Date();

  // Compare by UTC calendar days to avoid timezone drift
  const targetUTC = Date.UTC(
    target.getUTCFullYear(),
    target.getUTCMonth(),
    target.getUTCDate()
  );
  const todayUTC = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate()
  );

  // How many whole days ago the target was (negative means future)
  const daysAgo = Math.floor((todayUTC - targetUTC) / 86400000);

  // false if older than N days; true otherwise (including future)
  return daysAgo <= days;
};